import React from "react";
import { StyleSheet, Text, View } from "react-native";

interface Props {
  showError: boolean;
  textError: string;
}

const styles = StyleSheet.create({
  errorAlert: {
    color: "red",
    fontFamily: "Poppins"
  }
});

const NotifError = ({ showError, textError }: Props) => {
  return showError ? (
    <View>
      <Text style={styles.errorAlert}>{textError}</Text>
    </View>
  ) : (
    <></>
  );
};

export default NotifError;
